<template>
  <q-input
    id="autocomplete"
    ref="autocompleteRef"
    v-model="addressInput"
    :rules
    filled
    lazy-rules
    no-error-icon
    outlined
    placeholder="Enter an address"
  >
    <template #prepend>
      <q-icon name="location_on" />
    </template>
  </q-input>
</template>

<script lang="ts">
import type { QInput } from 'quasar'
import apiPromise from '@/setups/googleMaps'
import type { PropType } from 'vue'

export default {
  name: 'AddressAutocomplete',
  components: {},
  props: {
    value: {
      type: String,
      required: true
    },
    types: {
      type: Array<string>,
      default: ['address']
    },
    rules: {
      type: Array as PropType<Array<(val: string) => boolean | string>>,
      default: () => [(val: string) => !!val || 'Address is required']
    }
  },
  emits: ['click'],
  data() {
    return {
      addressInput: '',
      autocomplete: null as google.maps.places.Autocomplete | null
    }
  },
  computed: {},
  async mounted() {
    const callback = () => {
      const input = this.$refs.autocompleteRef?.$el.querySelector('input')
      if (!input) {
        console.error('Could not find input element')
        return
      }
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        types: this.types,
        componentRestrictions: { country: 'us' }
      })
      this.autocomplete.setFields(['address_components', 'geometry', 'formatted_address'])
      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete?.getPlace()
        if (!place) {
          return
        }
        this.onClick(place)
      })
    }
    this.addressInput = this.value
    if (this.autocomplete === null) {
      await apiPromise.then(callback)
    }
  },
  methods: {
    validate() {
      const ref = this.$refs['autocompleteRef'] as QInput
      return ref.validate()
    },
    onClick(selected: google.maps.places.PlaceResult) {
      if (!selected) {
        return
      }

      if (selected.formatted_address) {
        this.addressInput = selected.formatted_address
      }

      this.$emit('click', selected)
    }
  }
}
</script>
<style>
.pac-container {
  z-index: 9999 !important;
}
</style>
